import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Row,
  Table,
  Spinner,
  Pagination,
  Badge,
  Card,
  InputGroup
} from 'react-bootstrap';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import { ArrowLeft, FileEarmarkSpreadsheet, Printer } from 'react-bootstrap-icons';
import Header from '../../layouts/Header';
import { useNavigate } from 'react-router-dom';

const ItemWiseReport = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const navigate = useNavigate();

  const accessToken = localStorage.getItem("authToken");
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [selectedOutletName, setSelectedOutletName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryName, setselectedCategoryName] = useState("");
  const [error, setError] = useState('');
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isPrintBtnLoading, setIsPrintBtnLoading] = useState(false);
  const [productId, setProductId] = useState('');
  const [productsList, setProductsList] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(25);
  const [totals, setTotals] = useState({});
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
  const [classType, setClassType] = useState(null);

  const animatedComponents = makeAnimated();

  const classTypeOptions = [
    { value: 'COMBOS', label: 'COMBOS' },
    { value: 'DESSERTS', label: 'DESSERTS' },
    { value: 'EXTRAS', label: 'EXTRAS' },
    { value: 'FOOD', label: 'FOOD' },
    { value: 'BEVERAGE', label: 'BEVERAGE' },
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      borderRadius: "6px",
      minWidth: "200px",
      borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d",
    }),
  };

  useEffect(() => {
    const now = new Date();
    const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
    const end = new Date(currentDate.setHours(23, 59, 59, 999));

    setStartDate(start);
    setEndDate(end);
    getCategoryList();
    getOutlets();
    getProductsList();
  }, []);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
      const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
      getItemWiseReport(adjustedStartDate, adjustedEndDate, selectedOutlet, selectedCategory, productId, page, recordsPerPage, classType);
    }
  };

  const getOutlets = async () => {
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axios.get("outlet", { headers });

      if (response?.data?.status === true) {
        const filteredOutlets = response?.data?.data?.outlets.filter((act) => act?.status === "ACTIVE" || "INACTIVE");
        setOutlets(filteredOutlets);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const getCategoryList = async () => {
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axios.get("masters/category/get", { headers });

      if (response?.data?.status === true) {
        setCategoryList(response?.data?.data?.categories || []);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const getProductsList = async () => {
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axios.get("product", { headers });
      if (response?.data?.status === true) {
        setProductsList(response?.data?.data?.products || []);
        setFilteredProducts(response?.data?.data?.products || []);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleDownloadExcel = async () => {
    setDownloadBtnLoading(true);
    const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
    getItemWiseReport(adjustedStartDate, adjustedEndDate, selectedOutlet, selectedCategory, productId, currentPage, recordsPerPage, classType, true);
  };

  const getItemWiseReport = async (startDate, endDate, outlet, category, product, page, limit, cType, download) => {
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      };

      const updatedStartDate = startDate ? startDate.toISOString().split("T")[0] : null;
      const updatedEndDate = endDate ? endDate.toISOString().split("T")[0] : null;

      const queryParams = new URLSearchParams();
      queryParams.append('page', page);
      queryParams.append('limit', limit);
      if (updatedStartDate) queryParams.append('startDate', updatedStartDate);
      if (updatedEndDate) queryParams.append('endDate', updatedEndDate);
      if (outlet) queryParams.append('outletId', outlet);
      if (category) queryParams.append('category', category);
      if (product) queryParams.append('product', product);
      if (cType) queryParams.append('classType', cType);
      if (download) queryParams.append('isDownload', download);

      const response = await axios.get(`order/getItemWiseOrderReport?${queryParams.toString()}`, {
        headers,
        responseType: download ? 'blob' : 'json'
      });

      if (download) {
        // Create a blob from the response data
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // Create a link element
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        // Set the filename for the download
        const fileName = `${selectedOutletName} Item Wise Report For ${selectedCategoryName} (${updatedStartDate} - ${updatedEndDate}).xlsx`;
        link.download = fileName;

        // Append the link to the body and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        toast.success('Excel file downloaded successfully!', {
          position: "top-right",
          autoClose: 3000,
          theme: "light"
        });
      } else {
        setTotalPages(response?.data?.data?.pagination?.totalPages || 1);
        setProductList(response?.data?.data?.data || []);
        setFilteredData(response?.data?.data?.data || []);
        setTotals(response?.data?.data?.totals || {});
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
      setDownloadBtnLoading(false);
    }
  };

  const handleApiError = (error) => {
    let errorMessage = 'An error occurred';
    if (error.response?.status === 406) {
      errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
    } else if (error.response?.status === 412) {
      errorMessage = error.response?.data?.data?.message;
    } else if (error.response?.status === 500) {
      errorMessage = error.response?.data?.error;
    }

    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 3000,
      theme: "light",
    });
  };

  const handleEndDateChange = (date) => {

    const start = new Date(startDate);
    const end = new Date(date);

    // Remove time part
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const maxEndDate = new Date(start);
    maxEndDate.setDate(start.getDate() + 60);

    if (maxEndDate && startDate && maxEndDate < startDate) {
      setError('End date cannot be earlier than start date');
    } else {
      setError('');
      setEndDate(date);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setClicked(true);
    setBtnLoading(true);

    const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

    setCurrentPage(1);
    await getItemWiseReport(adjustedStartDate, adjustedEndDate, selectedOutlet, selectedCategory, productId, 1, recordsPerPage, classType);

    toast.success("Data Fetched Successfully", {
      position: "top-right",
      autoClose: 3000,
      theme: "light",
    });
    setBtnLoading(false);
  };

  const handlePrintReport = () => {
    setIsPrintBtnLoading(true);
    const formatDate = (date) => {
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    const tableContent = `
      <table style="border-collapse: collapse; width: 100%; font-size: 12px;">
        <thead>
          <tr style="background-color: #f8f9fa;">
            <th style="border: 1px solid #dee2e6; padding: 8px;">#</th>
            <th style="border: 1px solid #dee2e6; padding: 8px;">Date</th>
            <th style="border: 1px solid #dee2e6; padding: 8px;">Order #</th>
            <th style="border: 1px solid #dee2e6; padding: 8px;">Item</th>
            <th style="border: 1px solid #dee2e6; padding: 8px; text-align: center;">Qty</th>
            <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">MRP</th>
            <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">Rate</th>
            <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">Addon</th>
            <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">Discount</th>
            <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">Taxable</th>
            <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">Tax</th>
            <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">Total</th>
          </tr>
        </thead>
        <tbody>
          ${productList?.length > 0 ?
        productList.map((product, index) => `
              <tr>
                <td style="border: 1px solid #dee2e6; padding: 8px;">${index + 1}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px;">${product?.date}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px;">${product?.order_no}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px;">
                  <div style="color: #6f42c1;">${product?.category_name}</div>
                  <div>${product?.product_name}</div>
                  ${product?.orderStatus === "CANCELLED" ? `
                    <span style="color: #dc3545; font-size: 11px;">(CANCELLED)</span>
                  ` : ''}
                </td>
                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: center;">${product?.quantity || 0}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">${product?.mrpRate ? '₹ ' + product.mrpRate.toFixed(2) : '----'}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">${product?.rate ? '₹ ' + product.rate.toFixed(2) : '----'}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">₹ ${product?.totalAddonOfferPrice?.toFixed(2) || '0.00'}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; color: #dc3545;">₹ ${product?.discount?.toFixed(2) || '0.00'}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">₹ ${product?.taxable?.toFixed(2) || '0.00'}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">₹ ${product?.taxAmount?.toFixed(2) || '0.00'}</td>
                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-weight: bold; color: #28a745;">₹ ${product?.grand_total?.toFixed(2) || '0.00'}</td>
              </tr>
            `).join("") : `
              <tr>
                <td colspan="12" style="border: 1px solid #dee2e6; padding: 8px; text-align: center;">No items found</td>
              </tr>`
      }
          ${productList?.length > 0 ? `
            <tr style="font-weight: bold; background-color: #f8f9fa;">
              <td colspan="4" style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">TOTAL</td>
              <td style="border: 1px solid #dee2e6; padding: 8px; text-align: center;">${totals?.totalQuantity || 0}</td>
              <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">${totals?.totalMrpRate ? '₹ ' + totals.totalMrpRate.toFixed(2) : '----'}</td>
              <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">${totals?.totalRate ? '₹ ' + totals.totalRate.toFixed(2) : '----'}</td>
              <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">₹ ${totals?.totalAddonOfferPrice?.toFixed(2) || '0.00'}</td>
              <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; color: #dc3545;">₹ ${totals?.totalDiscount?.toFixed(2) || '0.00'}</td>
              <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">₹ ${totals?.totalTaxable?.toFixed(2) || '0.00'}</td>
              <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">₹ ${totals?.totalTaxAmount?.toFixed(2) || '0.00'}</td>
              <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; color: #28a745;">₹ ${totals?.totalGrandTotal?.toFixed(2) || '0.00'}</td>
            </tr>` : ''}
        </tbody>
      </table>
    `;

    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <head>
          <title>Item Wise Sales Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { display: flex; justify-content: space-between; margin-bottom: 20px; }
            .title { font-size: 18px; font-weight: bold; }
            .date-range { font-size: 14px; color: #666; }
            table { width: 100%; border-collapse: collapse; }
            th { background-color: #f8f9fa; text-align: left; }
          </style>
        </head>
        <body onload="window.print();window.close()">
          <div class="header">
            <div class="title">Item Wise Sales Report</div>
            <div class="date-range">${formattedStartDate} to ${formattedEndDate}</div>
          </div>
          ${tableContent}
        </body>
      </html>
    `);
    win.document.close();
    setIsPrintBtnLoading(false);
  };

  const renderPaginationItems = () => {
    const items = [];
    const maxVisiblePages = 5;
    let startPage, endPage;

    if (totalPages <= maxVisiblePages) {
      startPage = 1;
      endPage = totalPages;
    } else {
      const maxVisibleBeforeCurrent = Math.floor(maxVisiblePages / 2);
      const maxVisibleAfterCurrent = Math.ceil(maxVisiblePages / 2) - 1;

      if (currentPage <= maxVisibleBeforeCurrent) {
        startPage = 1;
        endPage = maxVisiblePages;
      } else if (currentPage + maxVisibleAfterCurrent >= totalPages) {
        startPage = totalPages - maxVisiblePages + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - maxVisibleBeforeCurrent;
        endPage = currentPage + maxVisibleAfterCurrent;
      }
    }

    if (startPage > 1) {
      items.push(
        <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" />);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" />);
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  const categoryOptions = categoryList.map((category) => ({
    value: category._id,
    label: category.name,
  }));

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
        <div className="card shadow-sm border-0">
          <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="mb-0 fw-bold d-inline-block">
                <i className="bi bi-box-seam me-2"></i>ITEM WISE SALES REPORT
              </h4>
            </div>
            <div>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => navigate('/reports/all-reports')}
                className="me-3 d-flex align-items-center fw-semibold"
                style={{ height: '38px' }}
              >
                <ArrowLeft className="me-1" /> Back to Reports
              </Button>
            </div>
          </div>
          <hr className='mt-0 mb-0' />

          <div className="card-body">
            {/* Filters Section */}
            <div className="p-3 bg-light rounded-3">
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col md={3}>
                    <Form.Group controlId="outletSelect">
                      <Form.Label className="fw-semibold">
                        <i className="bi bi-shop me-2"></i>Outlet
                        {!selectedOutlet && <span className="text-danger ms-2">(Required)</span>}
                      </Form.Label>
                      <Form.Select
                        value={selectedOutlet}
                        onChange={(e) => {
                          setSelectedOutletName(e.target.selectedOptions[0].label)
                          setSelectedOutlet(e.target.value)
                        }
                        }
                        className="border-secondary"
                      >
                        <option value="">Select Outlet</option>
                        {outlets?.map((outlet) => (
                          <option key={outlet?._id} value={outlet?._id} label={`${outlet?.name} (${outlet?.city})`}>
                            {outlet?.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group controlId="categorySelect">
                      <Form.Label className="fw-semibold">
                        <i className="bi bi-tags me-2"></i>Category
                        {!selectedCategory && <span className="text-danger ms-2">(Required)</span>}
                      </Form.Label>
                      <Select
                        isDisabled={!selectedOutlet}
                        options={categoryOptions}
                        value={categoryOptions.find(option => option.value === selectedCategory)}
                        onChange={(selectedOption) => {
                          const selectCategory = selectedOption?.value;
                          setselectedCategoryName(selectedOption?.label)

                          setSelectedCategory(selectCategory);
                          if (!selectCategory) {
                            setFilteredProducts(productsList);
                          } else {
                            setFilteredProducts(
                              productsList.filter((product) => product?.category?._id === selectCategory)
                            );
                          }
                        }}
                        isClearable
                        styles={customStyles}
                        placeholder="Select Category"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group controlId="productSelect">
                      <Form.Label className="fw-semibold">
                        <i className="bi bi-menu-button-wide me-2"></i>Menu Item
                      </Form.Label>
                      <Select
                        isDisabled={!selectedOutlet}
                        options={filteredProducts.map((product) => ({
                          value: product._id,
                          label: product.name,
                        }))}
                        value={
                          productId
                            ? { value: productId, label: filteredProducts.find((p) => p._id === productId)?.name }
                            : null
                        }
                        onChange={(selectedOption) => {
                          setProductId(selectedOption ? selectedOption.value : '');
                        }}
                        isClearable
                        styles={customStyles}
                        placeholder="Select Menu Item"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3} className="d-flex align-items-end">
                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      disabled={!selectedOutlet || !selectedCategory}
                    >
                      {btnLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Generate Report"
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>

            {/* Date Range Section */}
            <div className="p-3 bg-light rounded-3">
              <Row className="g-3">

                <Col md={3}>
                  <Form.Group controlId="startDate" style={{ display: 'flex', flexDirection: 'column' }}>
                    <Form.Label className="fw-semibold me-2">
                      <i className="bi bi-calendar me-2"></i>Start Date
                    </Form.Label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                        // Reset endDate if it exceeds 60 days from new startDate
                        if (endDate && date && endDate > new Date(date.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                          setEndDate(null);
                        }
                      }}
                      dateFormat="dd-MM-yyyy"
                      className="form-control border-secondary"
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="endDate" style={{ display: 'flex', flexDirection: 'column' }}>
                    <Form.Label className="fw-semibold me-2">
                      <i className="bi bi-calendar me-2"></i>End Date
                    </Form.Label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => {
                        if (startDate && date > new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                          setError("End date cannot be more than 60 days after start date");
                        } else {
                          setError("");
                          handleEndDateChange(date);
                        }
                      }}
                      dateFormat="dd-MM-yyyy"
                      minDate={startDate}
                      maxDate={startDate ? new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000) : null}
                      className="form-control border-secondary"
                    />
                    {error && <div className="text-danger small mt-1">{error}</div>}
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="classTypeSelect">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-list-check me-2"></i>Class Type
                    </Form.Label>

                    <Select
                      options={classTypeOptions}
                      value={classTypeOptions.find(
                        (option) => option.value === classType
                      )}
                      onChange={(selectedOption) => {
                        setClassType(selectedOption?.value || null);
                      }}

                      isClearable
                      styles={customStyles}
                      placeholder="Select Class Type"
                    />
                  </Form.Group>
                </Col>


                <Col md={3} className="d-flex align-items-end justify-content-end">
                  <Button
                    variant="outline-success"
                    className='fw-semibold w-100'
                    onClick={handleDownloadExcel}
                    disabled={!productList.length || isPrintBtnLoading}
                  >
                    {downloadBtnLoading ? (
                      <Spinner size="sm" animation="border" />
                    ) : (
                      <>
                        <FileEarmarkSpreadsheet className="me-2" />
                        Download Excel
                        {/* For Page {currentPage} */}
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
            </div>

            {/* Results Section */}
            {!clicked ? (
              <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                <div className="text-center">
                  <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                  <h5 className="text-muted mt-3">
                    Please select outlet, category and date range to view report
                  </h5>
                </div>
              </div>
            ) : (
              <>
                {/* Pagination and Records Per Page - Top */}
                <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                  <div className="d-flex align-items-center">
                    <span className="me-2 text-muted">Show</span>
                    <Form.Select
                      style={{ width: 'auto' }}
                      value={recordsPerPage}
                      onChange={(e) => {
                        const limit = Number(e.target.value);
                        setRecordsPerPage(limit);
                        setCurrentPage(1);
                        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                        getItemWiseReport(adjustedStartDate, adjustedEndDate, selectedOutlet, selectedCategory, productId, 1, limit, classType);
                      }}
                      className="border-secondary"
                    >
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={3000}>3000</option>
                      <option value={7000}>7000</option>
                    </Form.Select>
                    <span className="ms-2 text-muted">entries</span>
                  </div>

                  <Pagination>
                    <Pagination.Prev
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                    {renderPaginationItems()}
                    <Pagination.Next
                      disabled={currentPage === totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </Pagination>
                </div>

                {/* Items Table */}
                <div className="table-responsive border rounded-3">
                  <Table striped bordered hover className="mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th width="50">#</th>
                        <th width="100">Date</th>
                        <th width="100">Order #</th>
                        <th>Item</th>
                        <th width="80" className="text-center">Qty</th>
                        <th width="100" className="text-end">MRP</th>
                        <th width="100" className="text-end">Rate</th>
                        <th width="100" className="text-end">Addon</th>
                        <th width="100" className="text-end">Discount</th>
                        <th width="100" className="text-end">Taxable</th>
                        <th width="100" className="text-end">Tax</th>
                        <th width="120" className="text-end">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center py-4">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2 mb-0">Loading item data...</p>
                          </td>
                        </tr>
                      ) : filteredData?.length > 0 ? (
                        <>
                          {filteredData.map((product, index) => (
                            <tr key={index}>
                              <td className="text-muted">{(currentPage - 1) * recordsPerPage + index + 1}</td>
                              <td>{product?.date}</td>
                              <td>{product?.order_no}</td>
                              <td>
                                <div className="text-primary">{product?.category_name}</div>
                                <div>{product?.product_name}</div>
                                {product?.orderStatus === "CANCELLED" && (
                                  <Badge bg="danger" className="mt-1">CANCELLED</Badge>
                                )}
                              </td>
                              <td className="text-center">{product?.quantity}</td>
                              <td className="text-end">{product?.mrpRate ? `₹ ${product.mrpRate.toFixed(2)}` : '----'}</td>
                              <td className="text-end">{product?.rate ? `₹ ${product.rate.toFixed(2)}` : '----'}</td>
                              <td className="text-end">₹ {product?.totalAddonOfferPrice?.toFixed(2)}</td>
                              <td className="text-end text-danger">₹ {product?.discount?.toFixed(2)}</td>
                              <td className="text-end">₹ {product?.taxable?.toFixed(2)}</td>
                              <td className="text-end">₹ {product?.taxAmount?.toFixed(2)}</td>
                              <td className="text-end fw-semibold text-success">₹ {product?.grand_total?.toFixed(2)}</td>
                            </tr>
                          ))}
                          {currentPage === totalPages && (
                            <tr className="bg-light">
                              <td colSpan="4" className="text-end fw-bold">TOTAL</td>
                              <td className="text-center fw-bold">{totals?.totalQuantity || 0}</td>
                              <td className="text-end fw-bold">{totals?.totalMrpRate ? `₹ ${totals.totalMrpRate.toFixed(2)}` : '----'}</td>
                              <td className="text-end fw-bold">{totals?.totalRate ? `₹ ${totals.totalRate.toFixed(2)}` : '----'}</td>
                              <td className="text-end fw-bold">₹ {totals?.totalAddonOfferPrice?.toFixed(2)}</td>
                              <td className="text-end fw-bold text-danger">₹ {totals?.totalDiscount?.toFixed(2)}</td>
                              <td className="text-end fw-bold">₹ {totals?.totalTaxable?.toFixed(2)}</td>
                              <td className="text-end fw-bold">₹ {totals?.totalTaxAmount?.toFixed(2)}</td>
                              <td className="text-end fw-bold text-success">₹ {totals?.totalGrandTotal?.toFixed(2)}</td>
                            </tr>
                          )}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center py-4">
                            <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                            <p className="mt-2 mb-0 text-muted">
                              No items found for the selected criteria
                            </p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Pagination and Records Per Page - Bottom */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="text-muted">
                    Showing {(currentPage - 1) * recordsPerPage + 1} to{' '}
                    {Math.min(currentPage * recordsPerPage, filteredData?.length)} of{' '}
                    {filteredData?.length} entries
                  </div>
                  <Pagination>
                    <Pagination.Prev
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                    {renderPaginationItems()}
                    <Pagination.Next
                      disabled={currentPage === totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </Pagination>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ItemWiseReport;